export default __webpack_public_path__ + "static/media/expired_animated.3350c5c4.svg";